// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"blog-single-header-component_uk-open__MWqiS","grecaptcha-badge":"blog-single-header-component_grecaptcha-badge__qFTps","blog-single-header":"blog-single-header-component_blog-single-header__BBsoh","has-image":"blog-single-header-component_has-image__wpqIb","image":"blog-single-header-component_image__PqyZr","header-content":"blog-single-header-component_header-content__Bx59d"};
    if(module.hot) {
      // 1793877037240
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  